import { useParams, Outlet } from 'react-router'

const Documents = () => {
  const { documentsTab = '' } = useParams<{ documentsTab: string }>()

  return (
    <div className="documents-screen">
      <Outlet />
    </div>
  )
}

export default Documents
